var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-context-menu",on:{"click":function($event){$event.stopPropagation();},"contextmenu":function($event){$event.preventDefault();}}},[_c('layer-context-menu',{attrs:{"visible":_vm.visible,"x":_vm.x,"y":_vm.y,"items":_vm.items},on:{"select":function($event){return _vm.$emit('select', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }